import styled from 'styled-components'
import { Spacing, InlineChildren } from '@doordash/design-language'

export const BulletItem = styled.li`
  margin-bottom: ${Spacing.Small}px;
`

export const TitleContainer = styled(InlineChildren).attrs<{}>({
  size: InlineChildren.Sizes.XxxSmall
})`
  align-items: center;
`

export const StyledUL = styled.ul`
  padding-left: ${Spacing.XLarge}px;
`